<!-- 
Date picker component.

Allows dates to be typed in, or will display a date picker when clicked.
-->
<template>
  <v-menu
    v-model="showDatePicker"
    :close-on-content-click="false"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      ref="text"
      :value="dateFormatted"
      :label="label"
      :rules="[rules.validDate, required ? rules.required : rules.empty]"
      :validate-on-blur="validateOnBlur"
      :autofocus="autofocus"
      :outline="outline"
      :single-line="outline"
      :class="{'compact': outline}"
      clearable
      placeholder="DD/MM/YYYY"
      @input="cleared"
      @change="dateEntered"
      @focus="gotFocus"
      @blur="lostFocus"
    />
    <v-date-picker 
      :value="value"
      :min="dateMinValue"
      :max="dateMaxValue" 
      no-title
      scrollable
      @input="datePicked"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
import ruleMixins from "@/mixins/rule.mixins";

export default {
  mixins: [ruleMixins],
  props: {
    value: {
      default: "",
      type: String
    },
    label: {
      default: "",
      type: String
    },
    min: {
      default: "1900-01-01",
      type: String
    },
    max: {
      default: "2099-12-31",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    currentOrPast: {
      default: false,
      type: Boolean
    },
    currentOrFuture: {
      default: false,
      type: Boolean
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    outline: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      showDatePicker: false,
      validateOnBlur: false,
      dateMinValue: "",
      dateMaxValue: ""
    };
  },
  computed: {
    dateFormatted() {
      return this.value && this.rules.validDate(this.value) === true
        ? this.formatDateForDisplay(this.value)
        : this.value;
    },
    valid() {
      return this.$refs.text.valid;
    }
  },
  mounted() {
    this.dateMinValue = this.formatDateForPicker(
      this.currentOrFuture ? moment() : moment(this.min, this.dateFormatsAccepted)
    );
    this.dateMaxValue = this.formatDateForPicker(
      this.currentOrPast ? moment() : moment(this.max, this.dateFormatsAccepted)
    );
  },
  methods: {
    dateEntered(d) {
      if (d && this.rules.validDate(d) === true) {
        this.emit(d);
      }
    },
    datePicked(d) {
      this.showDatePicker = false;
      this.emit(d);
    },
    cleared(v) {
      if (!v) {
        this.emit("");
      }
    },
    emit(d) {
      const s = d && this.rules.validDate(d) === true ? this.formatDateForPicker(d) : d;
      this.$emit("input", s);
    },
    gotFocus() {
      this.validateOnBlur = true;
    },
    lostFocus() {
      this.$nextTick(function() {
        this.validateOnBlur = false;
      });
    },
    formatDateForDisplay(d) {
      return moment(d, this.dateFormatsAccepted).format(this.dateFormatForDisplay);
    },
    formatDateForPicker(d) {
      return moment(d, this.dateFormatsAccepted).format(this.dateFormatForPicker);
    }
  }
};
</script>
